import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function CompanyFilled(props) {
  const clipPathId = useClipPathId("company-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M21.1 9.4H15.1V4C15.1 2.9 14.2 2 13.1 2H3C1.9 2 1 2.9 1 4V22.9H7.8C7.4 22.8 7.1 22.5 7.1 22V19.8C7.1 19.3 7.5 18.9 8 18.9C8.5 18.9 9 19.3 9 19.8V22C9 22.4 8.7 22.7 8.3 22.9H13.4H15H22.3V10.7C22.4 10 21.8 9.4 21.1 9.4ZM6.9 17.2H4.7C4.2 17.2 3.8 16.8 3.8 16.3C3.8 15.8 4.2 15.4 4.7 15.4H6.9C7.4 15.4 7.8 15.8 7.8 16.3C7.8 16.8 7.4 17.2 6.9 17.2ZM6.9 13.8H4.7C4.2 13.8 3.8 13.4 3.8 12.9C3.8 12.4 4.2 12 4.7 12H6.9C7.4 12 7.8 12.4 7.8 12.9C7.8 13.4 7.4 13.8 6.9 13.8ZM6.9 10.3H4.7C4.2 10.3 3.8 9.9 3.8 9.4C3.8 8.9 4.2 8.5 4.7 8.5H6.9C7.4 8.5 7.8 8.9 7.8 9.4C7.8 9.9 7.4 10.3 6.9 10.3ZM6.9 6.8H4.7C4.2 6.8 3.8 6.4 3.8 5.9C3.8 5.4 4.2 5 4.7 5H6.9C7.4 5 7.8 5.4 7.8 5.9C7.8 6.4 7.4 6.8 6.9 6.8ZM11.5 17.2H9.3C8.8 17.2 8.4 16.8 8.4 16.3C8.4 15.8 8.8 15.4 9.3 15.4H11.5C12 15.4 12.4 15.8 12.4 16.3C12.4 16.8 12 17.2 11.5 17.2ZM11.5 13.8H9.3C8.8 13.8 8.4 13.4 8.4 12.9C8.4 12.4 8.8 12 9.3 12H11.5C12 12 12.4 12.4 12.4 12.9C12.4 13.4 12 13.8 11.5 13.8ZM11.5 10.3H9.3C8.8 10.3 8.4 9.9 8.4 9.4C8.4 8.9 8.8 8.5 9.3 8.5H11.5C12 8.5 12.4 8.9 12.4 9.4C12.4 9.9 12 10.3 11.5 10.3ZM11.5 6.8H9.3C8.8 6.8 8.4 6.4 8.4 5.9C8.4 5.4 8.8 5 9.3 5H11.5C12 5 12.4 5.4 12.4 5.9C12.4 6.4 12 6.8 11.5 6.8ZM19 17.2H16.8C16.3 17.2 15.9 16.8 15.9 16.3C15.9 15.8 16.3 15.4 16.8 15.4H19C19.5 15.4 19.9 15.8 19.9 16.3C19.9 16.8 19.5 17.2 19 17.2ZM19 13.8H16.8C16.3 13.8 15.9 13.4 15.9 12.9C15.9 12.4 16.3 12 16.8 12H19C19.5 12 19.9 12.4 19.9 12.9C19.9 13.4 19.5 13.8 19 13.8Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width="21.4"
              height="20.9"
              fill="white"
              transform="translate(1 2)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
